import { useMutation } from "react-query";
import api from "../../client";

const deleteData = async (id: string | undefined): Promise<void> => {
  const { data } = await api.delete(`/representatives/${id}`);

  return data;
};

export const useDeleteRepresentative = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
